import React from "react";

const FooterLink: React.FC<{ href: string; children: React.ReactNode }> = ({href, children}) => (
  <a href={href} target="_blank" rel="noreferrer" className="text-muted text-decoration-none px-1">{children}</a>
);

const PageFooter: React.FC = () => (
  <footer className="text-center text-muted py-3 small border-top mt-auto">
    &copy; {new Date().getFullYear()}
    <FooterLink href="https://boonelab.ccbr.utoronto.ca/">Boone</FooterLink>
    &amp;
    <FooterLink href="https://andrewslab.ccbr.utoronto.ca/">Andrews</FooterLink>Labs
    &middot;
    <FooterLink href="https://thedonnellycentre.utoronto.ca/">Donnelly Centre</FooterLink>
    &middot;
    <FooterLink href="https://www.utoronto.ca/">University of Toronto</FooterLink>
  </footer>
);

export default PageFooter;